// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__K87xM","content":"LayoutSettings_content__fmeNB"};